import { BaseQuestionnaireRoute } from '../slice';
import { automobilesRoutes, AutomobilesRoutes } from './automobiles';
import { homeOfficeRoutes, HomeOfficeRoutes } from './homeOffice';
import { bookKeepingRoutes, BookKeepingRoutes } from './bookKeeping';
import { compensationRoutes, CompensationRoutes } from './compensation';
import { balanceSheetRoutes, BalanceSheetRoutes } from './balanceSheet';
import {
  profitandLossStatementRoutes,
  ProfitandLossStatementRoutes,
} from './profitandLossStatement';
import { rentalActivityRoutes, RentalActivityRoutes } from './rentalActivity';
import {
  specialDeductionsInformationRoutes,
  SpecialDeductionsInformationRoutes,
} from './specialDeductionsInformation';
import {
  paycheckProtectionProgramPPPRoutes,
  PaycheckProtectionProgramPPPRoutes,
} from './paycheckProtectionProgramPPP';
import {
  miscellaneousInformationRoutes,
  MiscellaneousInformationRoutes,
} from './miscellaneousInformation';

export type AdditionalQuestionsRoutes = BaseQuestionnaireRoute & {
  automobiles: AutomobilesRoutes;
  homeOffice: HomeOfficeRoutes;
  bookKeeping: BookKeepingRoutes;
  compensation: CompensationRoutes;
  balanceSheet: BalanceSheetRoutes;
  profitandLossStatement: ProfitandLossStatementRoutes;
  rentalActivity: RentalActivityRoutes;
  specialDeductionsInformation: SpecialDeductionsInformationRoutes;
  paycheckProtectionProgramPPP: PaycheckProtectionProgramPPPRoutes;
  miscellaneousInformation: MiscellaneousInformationRoutes;
};

export const additionalQuestionsRoutes: {
  additionalQuestions: AdditionalQuestionsRoutes;
} = {
  additionalQuestions: {
    title: 'Additional Questions',
    path: 'additionalQuestions',
    isValid: undefined,
    ...automobilesRoutes,
    ...homeOfficeRoutes,
    ...bookKeepingRoutes,
    ...compensationRoutes,
    ...balanceSheetRoutes,
    ...profitandLossStatementRoutes,
    ...rentalActivityRoutes,
    ...specialDeductionsInformationRoutes,
    ...paycheckProtectionProgramPPPRoutes,
    ...miscellaneousInformationRoutes,
  },
};
